<template>
  <fh-container>
    <v-card-title
      >Configuración de unidades de medida<v-spacer></v-spacer>
      <v-dialog v-model="dialog" max-width="500px" persistent>
        <template v-slot:activator="{ on, attrs }">
          <v-col class="py-0">
            <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on">
              Nueva unidad de medida
            </v-btn>
          </v-col>
        </template>
        <v-card>
          <v-card-title>
            <span class="text-h5">{{ formTitle }}</span>
          </v-card-title>

          <v-card-text>
            <v-form ref="form" v-model="valid">
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      v-model="editedUnidadMedida.nombre"
                      label="Nombre"
                      :rules="commonRules"
                      :counter="nombreLength"
                      outlined
                      autofocus
                      ref="UnidadMedidaref"
                    ></v-text-field>
                  </v-col>
                  <v-col> </v-col>
                </v-row>
              </v-container>
            </v-form>
          </v-card-text>
          <v-card-text>
            <v-row class="text-center">
              <v-col class="py-0">
                <v-btn color="black" text @click="close" class="">
                  Cancelar
                </v-btn>
              </v-col>
              <v-col class="py-0">
                <v-btn color="primary" text @click="save"> Guardar </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-card-title>
    <v-row>
      <v-card outlined>
        <v-data-table
          :headers="headers"
          :items="listaUnidadesMedida"
          hide-default-footer
          :items-per-page="-1"
        >
          <template v-slot:[`item.actions`]="{ item }">
            <v-icon small class="mr-5" @click="editUnidadMedida(item)">
              fa-pen
            </v-icon>
            <v-icon small @click="deleteUnidadMedida(item)" color="error">
              fa-trash
            </v-icon>
          </template>
        </v-data-table>
        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card>
            <v-card-title class="text-h5 text-break"
              >¿Está seguro que quiere eliminar la unidad de medida
              seleccionada?</v-card-title
            >
            <v-card-text class="text-center text-h5 red--text">{{
              editedUnidadMedida.nombre
            }}</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="black" text @click="closeDelete">Cancelar</v-btn>
              <v-btn color="error" text @click="deleteUnidadMedidaConfirm"
                >Eliminar</v-btn
              >
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card>
    </v-row>
  </fh-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import FhContainer from "@/components/FhContainer";
import FhCard from "@/components/FhCard";
import ValoresRepository from "@/services/ValoresRepository";
export default {
  name: "AdminAgroUnidadesMedida",
  components: { FhCard, FhContainer },
  data() {
    return {
      // dialog flags
      dialog: false,
      dialogDelete: false,
      valid: false,
      saveDisabled: false,
      nombreLength: 30,
      commonRules: [
        (v) => !!v || "Campo obligatorio",
        (v) =>
          !v ||
          v.length <= this.nombreLength ||
          `No debe superar ${this.nombreLength} caracteres`,
      ],
      completeRules: [(v) => !!v || "Campo obligatorio"],
      editedIndex: -1,
      editedUnidadMedida: {
        idUnidadMedida: 0,
        nombre: "",
      },
      defaultUnidadMedida: {
        idUnidadMedida: 0,
        nombre: "",
      },
      headers: [
        { text: "Nombre", value: "nombre" },
        { text: "Acciones", value: "actions" },
      ],
    };
  },
  computed: {
    ...mapState("productos", ["listaUnidadesMedida"]),
    formTitle() {
      return this.editedIndex === -1
        ? "Nueva unidad de medida"
        : "Editar unidad de medida";
    },
  },
  methods: {
    ...mapActions("productos", [
      "fetchListaUnidadesMedida",
      "clearListaUnidadesMedida",
    ]),
    // Metodos de Unidad Medida
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedUnidadMedida = Object.assign({}, this.defaultUnidadMedida);
        this.editedIndex = -1;
      });
      this.$refs.form.resetValidation();
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedUnidadMedida = Object.assign({}, this.defaultUnidadMedida);
        this.editedIndex = -1;
      });
    },
    editUnidadMedida(unidadMedida) {
      this.editedIndex = this.listaUnidadesMedida.indexOf(unidadMedida);
      this.editedUnidadMedida = Object.assign({}, unidadMedida);
      this.dialog = true;
    },
    deleteUnidadMedida(unidadMedida) {
      this.editedIndex = this.listaUnidadesMedida.indexOf(unidadMedida);
      this.editedUnidadMedida = Object.assign({}, unidadMedida);
      this.dialogDelete = true;
    },
    async deleteUnidadMedidaConfirm() {
      await ValoresRepository.debajaUnidadMedida(
        this.editedUnidadMedida.idUnidadMedida
      );
      this.closeDelete();
      this.clearListaUnidadesMedida();
      await this.fetchListaUnidadesMedida();
    },
    async save() {
      try {
        if (!this.$refs.form.validate()) {
          return;
        }

        if (!this.saveDisabled) {
          this.saveDisabled = true;
          if (this.editedIndex > -1) {
            await ValoresRepository.actualizarUnidadMedida(
              this.editedUnidadMedida.idUnidadMedida,
              this.editedUnidadMedida.nombre
            );
          } else {
            await ValoresRepository.crearUnidadMedida(
              this.editedUnidadMedida.nombre
            );
          }
          this.editedUnidadMedida = Object.assign({}, this.defaultUnidadMedida);
          this.editedIndex = -1;

          this.clearListaUnidadesMedida();
          await this.fetchListaUnidadesMedida();
        }
      } catch (e) {
        this.saveDisabled = false;
      }
      this.saveDisabled = false;
      this.close();
    },
  },
  async created() {
    await this.fetchListaUnidadesMedida();
  },
};
</script>

<style></style>
